import { InputWrapper, Select, Text, Anchor } from "@mantine/core"
import { UseFormReturnType } from "@mantine/form"
import { Link } from "react-router-dom"

import {
  DatadogCIVisibilityDatasourceFormData,
  DatadogDatasourceFormData,
} from "@costory/types/endpoints/metricsDatasources"

import { QueryWrapper } from "@costory/front/components/layout/QueryWrapper"
import { useDatadogInstallationsQuery } from "@costory/front/queries/metricsDatasources"

interface DatadogInstallation {
  id: string
  name: string
  scope: string
}

interface DatadogConfigSelectProps {
  form:
    | UseFormReturnType<DatadogDatasourceFormData>
    | UseFormReturnType<DatadogCIVisibilityDatasourceFormData>
  query: ReturnType<typeof useDatadogInstallationsQuery>
}

export const DatadogConfigSelect = ({
  form,
  query,
}: DatadogConfigSelectProps) => (
  <QueryWrapper<DatadogInstallation[], unknown> query={query} allowEmptyArray>
    {({ data }) => {
      const datadogInstallation = data.filter((inst) => {
        const scopes = (inst.scope ?? "")
          .split(",")
          .map((s) => s.trim().toLowerCase())
          .filter(Boolean)
        return scopes.includes("metrics")
      }) as DatadogInstallation[]

      if (
        datadogInstallation.length > 0 &&
        !(form as UseFormReturnType<DatadogDatasourceFormData>).getInputProps(
          "datadogConfig",
        ).value
      ) {
        ;(form as UseFormReturnType<DatadogDatasourceFormData>).setFieldValue?.(
          "datadogConfig",
          datadogInstallation[0].id,
        )
      }
      return (
        <InputWrapper
          label={
            <Text fw="bold" span={true}>
              Datadog configuration
            </Text>
          }
          required
        >
          {datadogInstallation.length === 0 ? (
            <Text c="red" size="sm" mb={4}>
              No Datadog configurations found, create one in{" "}
              <Anchor
                component={Link}
                state={{ fromMetricsDatasources: true }}
                to="/integration"
              >
                Integrations
              </Anchor>
              .
            </Text>
          ) : (
            <Select
              {...(
                form as UseFormReturnType<DatadogDatasourceFormData>
              ).getInputProps("datadogConfig")}
              data={datadogInstallation.map(({ id, name }) => ({
                value: id,
                label: name,
              }))}
              onChange={(value) => {
                if (value) {
                  ;(
                    form as UseFormReturnType<DatadogDatasourceFormData>
                  ).setFieldValue?.("datadogConfig", value)
                }
              }}
              placeholder="Select a Datadog configuration"
              disabled={datadogInstallation.length === 0}
              autoComplete="on"
            />
          )}
        </InputWrapper>
      )
    }}
  </QueryWrapper>
)
